export enum THEME_NAMES {
  Unthemed = 'Unthemed',
  SleepioTheme = 'SleepioTheme',
}
